import { render, staticRenderFns } from "./editAddress.vue?vue&type=template&id=2516d473&scoped=true"
import script from "./editAddress.vue?vue&type=script&lang=js"
export * from "./editAddress.vue?vue&type=script&lang=js"
import style0 from "./editAddress.vue?vue&type=style&index=0&id=2516d473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2516d473",
  null
  
)

export default component.exports